<template>
  <v-container fluid>
    <!-- <v-card style="margin-bottom: 20px;">
      <v-card-title>Ownerships</v-card-title>
      <v-card-text>
        <p>
          Ownerships are the link between Devices and Organizations. An
          Application can give Ownership of a Device it owns to an Organization,
          This allows the Organization to set who can view the Device and its
          Events, They can also start and end Device Deployments.
        </p>
        <p>
          When an ownership has concluded, the current deployment of that device
          will also be concluded.
        </p>
        <p>
          Examples of Ownerships are "Device TA-0004 is currently owned by Test
          Organization", "Device 9998 is currently owned by Canterbury UC"
        </p>
      </v-card-text>
    </v-card>-->
    <v-card :loading="ownershipsLoading">
      <v-toolbar color="primary" dark>
        Ownerships
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon dark v-bind="attrs" v-on="on">mdi-information-variant</v-icon>
          </template>
          <p>
            Ownerships are the link between Devices and Organizations. An
            Application can give Ownership of a Device it owns to an
            Organization, This allows the Organization to set who can view the
            Device and its Events, They can also start and end Device
            Deployments.
          </p>
          <p>
            When an ownership has concluded, the current deployment of that
            device will also be concluded.
          </p>
          <p>
            Examples of Ownerships are "Device TA-0004 is currently owned by
            Test Organization", "Device 9998 is currently owned by Canterbury
            UC"
          </p>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchOwnerships"
          label="Search"
          single-line
          hide-details
          prepend-icon="mdi-magnify"
          clearable
          v-on:input="onQuickFilterChanged()"
        ></v-text-field>
      </v-toolbar>
      <expandedToolbar :newButton="true" @newButtonClick="newOwnershipDialog = true" />
      <v-card-text v-if="ownerships">
        <v-row>
          <v-col style="height: calc(100vh - 230px) !important;" cols="12">
            <ag-grid-vue
              :style="{ width, height }"
              class="ag-theme-alpine"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowData"
              :animateRows="true"
              rowSelection="multiple"
              @grid-ready="onGridReady"
              @cellDoubleClicked="onCellDoubleClick"
            ></ag-grid-vue>
          </v-col>
        </v-row>
        <!-- <v-data-table
          :headers="ownershipsHeaders"
          :items="ownerships"
          :search="searchOwnerships"
          :items-per-page="10"
          item-key="name"
          sort-by="id"
          :sort-desc="true"
          class="elevation-0"
          :loading="ownershipsLoading"
        >
          <template v-slot:item.activeDeployment="{ item }">
            <div>
              <span style="color: green;" v-if="item.activeDeployment > 0">True</span>
              <span style="color: red;" v-else>False</span>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="!item.end_ts" @click="endOwnership(item)">
                    <v-list-item-title>End Ownership</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>-->
      </v-card-text>
    </v-card>
    <v-dialog v-model="manageOwnershipDialog" persistent max-width="600px">
      <v-card v-if="ownerships" tile>
        <v-toolbar color="primary" dark>
          Manage Ownership
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            icon
            dark
            @click="
              manageOwnershipDialog = false;
              ownershipFormData = {};
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="ownershipFormData.name" label="Ownership Name"></v-text-field>
              </v-col>
              <!-- <v-col v-if="applications" cols="12">
                <v-select
                  v-model="ownershipFormData.applications_id"
                  :items="applications"
                  :rules="[value => !!value || 'Application is Required.']"
                  item-text="name"
                  item-value="id"
                  label="Application"
                  required
                ></v-select>
              </v-col>-->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="manageOwnershipLoading" @click="saveOwnership()" color="success">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newOwnershipDialog" persistent max-width="600px">
      <v-card v-if="ownerships" tile>
        <v-toolbar color="primary" dark>
          New Ownership
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="newOwnershipDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="ownershipFormData.organizations_id"
                  :items="organizations"
                  :rules="[(value) => !!value || 'Organization is Required.']"
                  item-text="name"
                  item-value="id"
                  label="Organization"
                  @change="filterDevices"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  :disabled="!deviceFiltered"
                  v-model="ownershipFormData.devices_id"
                  :items="filteredDevices"
                  :rules="[(value) => !!value || 'Application is Required.']"
                  item-text="id"
                  item-value="id"
                  label="Device"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="newOwnershipLoading"
            @click="generateNewOwnership()"
            color="success"
          >Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="aGGridActionMenu" persistent max-width="300px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Action Menu
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="updateAGGridActionMenu()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-list v-if="selectedRowData" dense>
                  <!-- <v-list-item :to="'/dashboard'">
                    <v-list-item-action>
                      <v-icon>mdi-account-box</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Event Profile</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>-->
                  <v-list-item v-if="!selectedRowData.end_ts" @click="endOwnership()">
                    <v-list-item-action>
                      <v-icon>mdi-block-helper</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>End Ownership</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item style="text-align: center" v-else>
                    <v-list-item-content>
                      <v-list-item-title>No Actions Available</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="endOwnershipLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import agGridActionButton from "@/components/agGridActionButton";
  import agGridActiveDeployment from "@/components/agGridActiveDeployment";
  import expandedToolbar from "@/components/expandedToolbar.vue";
  import { AgGridVue } from "ag-grid-vue";
  import moment from "moment";

  export default {
    components: {
      AppBar,
      AgGridVue,
      agGridActionButton,
      agGridActiveDeployment,
      expandedToolbar,
    },
    computed: {
      ...mapGetters([
        "currentUser",
        "currentUserData",
        "aGGridActionMenu",
        "selectedRowData",
        "ownerships",
        "ownershipsLoading",
        "organizations",
        "organizationsLoading",
        "devices",
        "devicesLoading",
      ]),
    },
    props: {
      source: String,
    },
    data: () => ({
      // AG-Grid
      columnDefs: null,
      rowData: null,
      columnApi: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        autoHeight: true,
      },
      width: "100%",
      height: "100%",

      drawer: null,
      ownershipsHeaders: [
        {
          text: "ID",
          align: "left",
          sortable: true,

          value: "id",
          width: "80px",
        },
        {
          text: "Start",
          value: "start_ts",
        },
        {
          text: "End",
          value: "end_ts",
        },
        {
          text: "Org ID",
          value: "organizations_id",
        },
        {
          text: "Org Name",
          value: "organizations_name",
        },
        {
          text: "App ID",
          value: "applications_id",
        },
        {
          text: "App Name",
          value: "applications_name",
        },
        {
          text: "App Prefix",
          value: "applications_prefix",
        },
        {
          text: "Device ID",
          value: "devices_id",
        },
        {
          text: "Deployments",
          value: "deployments",
        },
        {
          text: "Currently Deployed",
          value: "activeDeployment",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
      searchOwnerships: "",
      //New Ownerships
      newOwnershipDialog: false,
      newOwnershipLoading: false,
      //Manage Ownerships
      manageOwnershipDialog: false,
      manageOwnershipLoading: false,
      endOwnershipLoading: false,
      //OwnershipFormData
      ownershipFormData: {},

      deviceFiltered: false,
      filteredDevices: [],
    }),
    beforeMount() {
      this.columnDefs = [
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "agGridActionButton",
        },
        {
          headerName: "ID",
          field: "id",
        },
        {
          headerName: "Start",
          field: "start_ts",
          valueFormatter: startAtFormatter,
        },
        {
          headerName: "End",
          field: "end_ts",
          valueFormatter: endAtFormatter,
        },
        {
          headerName: "Org Name",
          field: "organizations_name",
        },
        {
          headerName: "App Name",
          field: "applications_name",
        },
        {
          headerName: "Device ID",
          field: "devices_id",
        },
        {
          headerName: "Deployments",
          field: "deployments",
        },
        {
          headerName: "Currently Deployed",
          field: "activeDeployment",
          cellRendererFramework: "agGridActiveDeployment",
        },
      ];
      this.context = { componentParent: this };
      // this.gridOptions
      this.$store.dispatch("loadOwnerships").then(() => {
        this.rowData = this.ownerships;
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      });
      if (this.aGGridActionMenu == true) {
        this.$store.dispatch("setAGGridActionMenuState", {});
      }
    },
    mounted() {
      this.$store.dispatch("loadOrganizations");
      this.$store.dispatch("loadDevices");
      // To demonstrate functionality of exposed component functions
      // Here we make focus on the user input
      // this.$refs.address.focus();
    },
    watch: {
      ownerships: function (oldOwn, newOwn) {
        this.rowData = this.ownerships;
        this.endOwnershipLoading = false;
      },
    },
    methods: {
      onQuickFilterChanged() {
        this.gridApi.setQuickFilter(this.searchOwnerships);
      },
      onGridReady(params) {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
      },
      autoSizeColumnsAGGRID() {
        // this.gridApi.sizeColumnsToFit();
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      },
      onCellDoubleClick(cell) {
        this.$store.dispatch("setAGGridActionMenuState", cell.data);
      },
      updateAGGridActionMenu() {
        this.$store.dispatch("setAGGridActionMenuState", {});
      },
      filterDevices() {
        this.deviceFiltered = false;
        let org = this.organizations.find(
          (o) => o.id == this.ownershipFormData.organizations_id
        );
        let devices = this.devices.filter(
          (d) => d.applications_id == org.applications_id && !d.ownerships_id
        );
        this.filteredDevices = devices;
        this.deviceFiltered = true;
      },
      generateNewOwnership() {
        this.newOwnershipLoading = true;
        this.$store
          .dispatch("newOwnership", this.ownershipFormData)
          .then((result) => {
            this.newOwnershipLoading = false;
            this.newOwnershipDialog = false;
            this.$swal({
              title: "Success!",
              text: `${this.ownershipFormData.devices_id} is now under Ownership of ${this.ownershipFormData.organizations_id}`,
              type: "success",
              confirmButtonText: "Ok",
            });
            this.ownershipFormData = {};
          });
      },
      endOwnership() {
        this.endOwnershipLoading = true;
        this.$store
          .dispatch("endOwnership", this.selectedRowData)
          .then((result) => {
            this.updateAGGridActionMenu();
            this.$swal({
              title: "Success!",
              text: `The Ownership between ${o.devices_id} and ${o.organizations_name} has been concluded. Any active deployments have been ended aswell.`,
              type: "success",
              confirmButtonText: "Ok",
            });
          });
      },
      // openManageOwnership(item) {
      //   this.ownershipFormData = {
      //     id: item.id,
      //     o: item.name,
      //     applications_id: item.applications_id
      //   };
      //   this.manageOwnershipDialog = true;
      // },
      // saveOwnership() {
      //   this.manageOwnershipLoading = true;
      //   this.$store
      //     .dispatch("saveOwnership", this.ownershipFormData)
      //     .then(result => {
      //       this.manageOwnershipLoading = false;
      //       this.manageOwnershipDialog = false;
      //       this.$swal({
      //         title: "Success!",
      //         text: `${this.ownershipFormData.name} was Saved`,
      //         type: "success",
      //         confirmButtonText: "Ok"
      //       });
      //       this.ownershipFormData = {};
      //     });
      // }
    },
  };
  window.startAtFormatter = function startTimeFormatter(params) {
    if (params.data.start_ts) {
      return moment
        .utc(params.data.start_ts)
        .local()
        .format("MMMM Do YYYY, h:mm:ss a");
    } else {
      return "";
    }
  };
  window.endAtFormatter = function endTimeFormatter(params) {
    if (params.data.end_ts) {
      return moment
        .utc(params.data.end_ts)
        .local()
        .format("MMMM Do YYYY, h:mm:ss a");
    } else {
      return "";
    }
  };
</script>
